import type { Document } from '../../types'
import DocumentCard from './DocumentCard'

interface DocumentGridProps {
  documents: Document[]
  linkPrefix?: string
}

export default function DocumentGrid({ documents, linkPrefix = '' }: DocumentGridProps) {
  return (
    <div
      className="grid gap-3"
      style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))' }}
      data-testid="document-grid"
    >
      {documents.map((doc) => (
        <DocumentCard
          key={doc.document_id}
          document={doc}
          linkPrefix={linkPrefix}
          variant="grid"
        />
      ))}
    </div>
  )
}
